'use client';
import { Home, Megaphone, Menu } from 'lucide-react';
import Link from 'next/link';
import { Accordion } from '../../ui/accordion.jsx';
import { Button } from '../../ui/button.jsx';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from '../../ui/sheet.jsx';
import { HelpCenterNavButton } from '../../ui-custom/help-center-nav-button.jsx';
import { ThemeToggle } from '../../../contexts/theme-toggle.jsx';
import { cn } from '../../../lib/utils.js';
import { Logo } from './logo';
import { LoginButton } from './login-button';
import { MobileMenuItem } from './menu-item';
import { UserNav } from './user-nav';
export var MobileMenu = function (_a) {
    var logo = _a.logo, menu = _a.menu, _b = _a.mobileExtraLinks, mobileExtraLinks = _b === void 0 ? [] : _b, auth = _a.auth, userAvatarSlot = _a.userAvatarSlot, showThemeToggle = _a.showThemeToggle, className = _a.className, _c = _a.hideLogo, hideLogo = _c === void 0 ? false : _c, _d = _a.showFanVoice, showFanVoice = _d === void 0 ? false : _d, helpCenterUrl = _a.helpCenterUrl, startSlot = _a.startSlot, endSlot = _a.endSlot;
    return (<div className="block lg:hidden">
      <div className="flex items-center justify-between gap-3">
        {!hideLogo && <Logo {...logo}/>}
        {startSlot && <div className="flex min-w-0 flex-1 items-center">{startSlot}</div>}
        <div className="flex items-center gap-2">
          {endSlot}
          <Sheet>
            <SheetTrigger asChild>
              <Button variant="outline" size="icon" aria-label="Open mobile menu">
                <Menu className="size-4"/>
              </Button>
            </SheetTrigger>
            <SheetContent className={cn('gap-0 overflow-y-auto', className)} aria-label="Mobile menu">
              <SheetHeader className="p-6 pb-0">
                <SheetTitle>
                  <Logo {...logo}/>
                </SheetTitle>
              </SheetHeader>
              <nav aria-label="Mobile navigation">
                <div className="my-6 flex flex-col gap-6 px-6">
                  <Accordion type="single" collapsible className="flex w-full flex-col gap-4">
                    {menu.map(function (item) { return (<MobileMenuItem key={item.key || item.title} item={item}/>); })}
                  </Accordion>
                  {mobileExtraLinks.length > 0 && (<div className="grid grid-cols-2 justify-start border-t py-4">
                      {mobileExtraLinks.map(function (link, idx) { return (<Link key={idx} className="text-muted-foreground hover:bg-muted hover:text-accent-foreground inline-flex h-10 items-center gap-2 rounded-md px-4 py-2 text-sm font-medium whitespace-nowrap transition-colors" href={link.url}>
                          {link.name}
                        </Link>); })}
                    </div>)}
                  <div className="flex flex-col gap-3">
                    {auth.showAccount && (<Button asChild variant="outline">
                        <Link href="/account">
                          <Home className="h-4 w-4"/> Account
                        </Link>
                      </Button>)}
                    {auth.showUserNav && (<div className="flex items-center justify-center">
                        <UserNav logout={auth.logout} userAvatarSlot={userAvatarSlot} citizenPortalUrl={auth.citizenPortalUrl} governmentPortalUrl={auth.governmentPortalUrl} settingsUrl={auth.settingsUrl} showAdmin={auth.showAdmin} showAccount={auth.showAccount} userMenuLabel={auth.userMenuLabel}/>
                      </div>)}
                    {auth.login && (<LoginButton loginUrl={auth.login.url}>{auth.login.text}</LoginButton>)}
                    {auth.signup && (<LoginButton loginUrl={auth.signup.url} isSignup variant="default">
                        {auth.signup.text}
                      </LoginButton>)}
                    <div className="flex items-center justify-center">
                      <HelpCenterNavButton href={helpCenterUrl} showText/>
                    </div>
                    {showFanVoice && (<Button asChild variant="ghost" size="sm" title="Report an Issue">
                        <Link target="_blank" href="https://govinity.fanvoice.ai/reportissue/bugs-features">
                          <Megaphone className="h-4 w-4"/>
                        </Link>
                      </Button>)}
                    {showThemeToggle && (<div className="flex items-center justify-center">
                        <ThemeToggle />
                      </div>)}
                  </div>
                </div>
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </div>);
};
